import { render, staticRenderFns } from "./QUpload.vue?vue&type=template&id=35d046e8&scoped=true&"
import script from "./QUpload.vue?vue&type=script&lang=js&"
export * from "./QUpload.vue?vue&type=script&lang=js&"
import style0 from "./QUpload.vue?vue&type=style&index=0&id=35d046e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d046e8",
  null
  
)

export default component.exports